/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorIcon20Light = forwardRef('TechScreenMonitorIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h3v2H6a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1h-2v-2h3a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5Zm10 11a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10Zm-4 1v2H9v-2h2Z" })));
});
